import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import { homeStyles as useStyles } from "./styles";

function Home() {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <section className={classes.welcome}>
          <div className={classes.welcomeIntro}>
            <Typography className={classes.introTitle}>
              SEJA BEM-VINDO!
            </Typography>
            <Typography className={classes.introCaption}>
              Faça você mesmo a revisão e o cálculo de restituição de INSS de Pessoa Física recolhido acima do teto máximo.
            </Typography>
          </div>
        </section>
      </CardContent>
    </Card>
  );
}

export default Home;
